/* eslint-disable import/extensions */
import tracking from '@titanio/tracking'
import { IdleQueue } from 'idlize/IdleQueue.mjs'

const loader = () => {
  const queue = new IdleQueue({
    ensureTasksRun: true,
  })

  queue.pushTask(() => {
    tracking.mount()

    /**
     * when user is not logged (anonymous visit)
     */
    tracking.send()

    /**
     * when user is logged
     */
    if (window.__user__) {
      tracking.send({ credentials: true })
    }
  })
}

export default { loader }
